import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "flex flex-col justify-center items-center w-full h-screen" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "text-center text-4xl lg:text-6xl font-bold lg:font-semibold leading-10 lg:leading-[5.5rem] text-[#F26634]" }, " เรากำลังช่วยคุณตรวจสอบเว็บไซต์ ", -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "text-center mt-4 text-sm lg:text-xl font-normal leading-5 lg:leading-7 text-[#667085]" }, " โดยปกติจะใช้เวลาประมาณ 15 วินาทีรายงานจะแสดงที่นี่เมื่อเสร็จสิ้น ", -1)
const _hoisted_4 = {
  ref: "searching",
  id: "searching",
  class: "w-[18.75rem] h-[18.75rem] lg:w-[28.125rem] lg:h-[28.125rem]"
}
const _hoisted_5 = { class: "mt-2 font-semibold text-4xl leading-5 text-[#2B3BA6]" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _hoisted_3,
    _createElementVNode("div", _hoisted_4, null, 512),
    _createElementVNode("div", _hoisted_5, _toDisplayString(_ctx.percentage) + " % ", 1)
  ]))
}